import React from 'react';
import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';

const StyledDot = styled.div`
  width: ${globalTheme.spacing.xs};
  height: ${globalTheme.spacing.xs};
  margin-right: ${globalTheme.spacing.xs};
  border-radius: ${globalTheme.spacing.xs};
  background-color: ${({ active }) => (active ? globalTheme.palette.brand.cloudinaryBlue : globalTheme.palette.brand.accentLightBlue)};
`;

export const DotStep = (props) => {
  return <StyledDot {...props} />;
};
